module.exports = __webpack_public_path__ + "assets/images/scene-1_8e8c42e8e61b14cd090096ba997df2ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-two/croma-abeldo-dialogs/scene-1.png
// module id = 219
// module chunks = 0